import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

export const TechnologiesTableWrapper = styled.div`
    border-top: 1px solid ${colorsPalettes.carbon["100"]};
    .ant-table-header {
        top: 48px !important;
    }
`;

export const StyledSearchTechnologyWrapper = styled.div`
    input[disabled] {
        background: none !important;
    }
`;
